/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_Studio_Topic_HintInputs */

const en_directory_ai_tools_studio_topic_hint = /** @type {(inputs: Directory_Ai_Tools_Studio_Topic_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Real names and one funny detail make it yours. Leave it empty for a general hype verse.`)
};

const zh_directory_ai_tools_studio_topic_hint = /** @type {(inputs: Directory_Ai_Tools_Studio_Topic_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`写上真名和一个好笑的细节，歌词就是专属的。留空则生成通用的炸场歌词。`)
};

/**
* | output |
* | --- |
* | "Real names and one funny detail make it yours. Leave it empty for a general hype verse." |
*
* @param {Directory_Ai_Tools_Studio_Topic_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_topic_hint = /** @type {((inputs?: Directory_Ai_Tools_Studio_Topic_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Topic_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_topic_hint(inputs)
	return zh_directory_ai_tools_studio_topic_hint(inputs)
});
export { directory_ai_tools_studio_topic_hint as "directory.ai_tools.studio.topic_hint" }